import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useUserAuth } from "../../context/UserAuthContext";
import { MdDelete } from "react-icons/md";

const InvoiceTerms = () => {
  const { user, token } = useUserAuth();
  const user_id = user?.uid;
  const [termText, setTermText] = useState("");
  const [terms, setTerms] = useState([]);
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  useEffect(() => {
    if (!user_id) return;

    const fetchInvoiceTerms = async () => {
      try {
        const response = await axios.get(`${base_url}/api/v1/invoice-terms/${user_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
        setTerms(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching terms:", err);
        toast.error("Failed to fetch terms.");
      }
    };

    fetchInvoiceTerms();
  }, [user_id]);

  const addTerm = async (e) => {
    e.preventDefault();
    if (!termText.trim()) {
      toast.error("Write something to add.");
      return;
    }

    try {
      const formData = { term: termText, user_id };
      const response = await axios.post(`${base_url}/api/v1/invoice-terms`,
        formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
      );
      const newTerm = response.data.data;
      setTerms((prevTerms) => [...prevTerms, newTerm]);
      setTermText("");
      toast.success("Term added successfully.");
    } catch (err) {
      console.error("Error adding term:", err);
      toast.error("Failed to add term.");
    }
  };

  const deleteTerm = async (id) => {
    if (!window.confirm("Are you sure you want to delete this term?")) return;

    try {
      await axios.delete(`${base_url}/api/v1/invoice-terms/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      setTerms((prevTerms) => prevTerms.filter((term) => term.id !== id));
      toast.success("Term deleted successfully.");
    } catch (err) {
      console.error("Error deleting term:", err);
      toast.error("Failed to delete term.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#085f9a" }}
              >
                Manage Your Terms and Conditions
              </div>
              <div className="card-body">
                <form onSubmit={addTerm}>
                  <div className="form-group">
                    <label htmlFor="Term">Term</label>
                    <input
                      type="text"
                      name="termText"
                      placeholder="Enter Term"
                      className="form-control"
                      id="Term"
                      value={termText}
                      onChange={(e) => setTermText(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={!termText.trim()}
                    className="btn text-white"
                    style={{ backgroundColor: "#085f9a" }}
                  >
                    Submit
                  </button>
                </form>
              </div>
              <div className="card-footer bg-white">
                <hr />
                <h3>Terms and Conditions</h3>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Description</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {terms.length > 0 ? (
                        terms.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.term}</td>
                            <td>
                              <MdDelete
                                size={24}
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => deleteTerm(item.id)}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No terms available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceTerms;
